var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.data)?_c('div',{staticClass:"d-flex flex-row align-items-center"},[_c('p',{staticClass:"action plot",on:{"click":function($event){return _vm.plotTrades(_vm.params.data)}}},[_vm._v(" Plot ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }